import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  dangerAlert: {
    marginTop: 5,
    padding: '0 0 0 15px',
    backgroundColor: 'transparent',
    border: 0,
    whiteSpace: 'pre-line',
    position: 'relative',
    color: custom.status.danger.contrastText,
    fontSize: 12,
    zIndex: 1,
  },
  spaceTop: {
    marginTop: 12,
  },
  checkboxValidationMessage: {
    fontSize: 14,
    paddingLeft: 0,
    marginTop: -3,
    marginBottom: 8,
  },
  leasingVehicleTypeMessage: {
    fontSize: 14,
    padding: 0,
    lineHeight: '20px',
  },
}));
